import Link from 'next/link'
import BlogCard from './BlogCard'

export default function FeaturedBlogs({ blogs }: { blogs: any[] }) {
  const featuredBlogs = blogs.filter((b) => b.featured)

  if (featuredBlogs.length === 0) return null

  return (
    <section className="bg-gradient-to-r from-gray-50 to-gray-100 py-8 md:py-12 lg:py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 md:mb-8">Empfohlene Artikel</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-8">
          {featuredBlogs.map((b: any) => (
            <BlogCard key={b.slug} blog={b} priority={false} />
          ))}
        </div>
        <div className="text-center">
          <Link
            href="/blogs"
            className="inline-block bg-[#0066CC] hover:bg-[#004BA6] text-white px-8 py-3 md:py-4 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105"
          >
            Alle Blogs ansehen
          </Link>
        </div>
      </div>
    </section>
  )
}
